<template>
	<div class="">
		<div class="flex items-center justify-between pb-[6px] bB-03 mb-[54px]">
			<div class="flex items-center">
				<div @click="navClick(item,index)" v-for="(item,index) in navList" :key="index"
					:class="type==index?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
					class="navTitle cursor-pointer  relative text-[16px] mr-[34px]">
					{{item.title}}
				</div>
			</div>
		</div>
		<div class="">
			<div class="flex items-start mb-[14px]">
				<label class="min-w-[90px] mr-[6px] text-[14px] text-[#999999]">{{langInfo.email_address}}:</label>
				<el-input v-model="userInfo.email" size="small" class="w-[180px]"
					:placeholder="langInfo.login_email_tip"></el-input>

			</div>
			<div class="flex  mb-[14px]">
				<label class="min-w-[90px] mr-[6px] text-[14px] text-[#999999]">{{langInfo.code}}:</label>

				<div class="flex items-center">
					<el-input v-model="code" size="small" class="w-[180px] mr-[6px]"
						:placeholder="langInfo.reg_code_tip"></el-input>
					<div @click="getCodeClick()"
						class="text-white cursor-pointer  rounded-[5px] bg-[#FF0000] text-center w-[130px] h-[26px] leading-[26px]">
						{{getCodeText}}
					</div>
				</div>


			</div>
			<div class="flex items-start mb-[14px]">
				<label class="min-w-[90px] mr-[6px] text-[14px] text-[#999999]">{{langInfo.reset_password}}:</label>

				<el-input v-model="password" type="number" size="small" class="w-[180px] h-[26px]"
					:placeholder="langInfo.login_password_tip" show-password></el-input>
				<!-- <input  type="password" class="w-[180px] text-[#C1C2C5] text-[14px] rounded-[3px]"
					 /> -->
			</div>
			<div class="flex items-start mb-[30px]">
				<label class="min-w-[90px] mr-[6px] text-[14px] text-[#999999]">{{langInfo.confirm_password}}:</label>

				<el-input v-model="nextPassword" type="number" size="small" class="w-[180px] h-[26px]"
					:placeholder="langInfo.reg_password_tip" show-password></el-input>
				<!-- 		<input v-model="nextPassword" type="password" class="w-[180px] text-[#C1C2C5] text-[14px] rounded-[3px]"
					:placeholder="langInfo.reg_password_tip" /> -->
			</div>
		</div>
		<div @click="saveBtn()"
			class="w-[250px] h-[36px] mb-[25px] cursor-pointer leading-[36px] text-center text-[#ffffff] rounded-[5px] bg-[#FF0000] ">
			{{langInfo.study_paper_confirm}}
		</div>

		<div class="text-[#FF0000]">
			{{langInfo.update_password_tip}}
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				type: 0,
				navList: [{
					title: '', //修改密码
				}],
				userInfo: {},
				getCodeText: '',
				getCodeisWaiting: false,
				langInfo: {},
				code: '',
				password: '',
				nextPassword: "",
			}
		},
		mounted() {
			
			this.password=""
			this.nextPassword=""
			this.code=""
			
			this.getUser()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.getCodeText = this.langInfo.reg_get_code
				this.navList[0].title = this.langInfo.study_password
				
				document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_password
			}
		},
		methods: {
			// 获取验证码
			getCodeClick() {
				if (!this.userInfo.email) {
					this.$message({
						message: this.langInfo.login_email_tip,
						type: 'warning'
					});
					return
				}


				if (this.getCodeisWaiting) {
					return
				}
				this.getCodeText = this.langInfo.sending //发送验证码
				this.getCodeisWaiting = true;

				this.getCode()
			},
			getCodeTimer() {
				let holdTime = 60; //定义变量并赋值
				// this.getCodeText = "重新获取60s"
				this.Timer = setInterval(() => {
					if (holdTime <= 0) {
						this.getCodeisWaiting = false;
						this.getCodeText = this.langInfo.reg_get_code
						clearInterval(this.Timer); //清除该函数
						return; //返回前面
					}
					this.getCodeText = this.langInfo.re_obtain + holdTime + "s"
					holdTime--;
				}, 1000)
			},
			getCode() {
				this.$api.sendResetPasswordCode({
					email: this.userInfo.email,
					type: 'reset_password_code'
				}).then((res) => {
					console.log(res);
					this.$message({
						message: res.msg,
						type: 'success'
					})
					this.getCodeTimer()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.getCodeText = this.langInfo.reg_get_code
					this.navList[0].title = this.langInfo.study_password
					document.title = this.langInfo.pc_name+'-'+this.langInfo.study_password
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getUser() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			saveBtn() {
				let that=this
				
			
				
				if (!this.userInfo.email) {
					this.$message({
						message: this.langInfo.login_email_tip,
						type: 'warning'
					});
					return
				}
				
				if (!this.code) {
					this.$message({
						message: this.langInfo.reg_code_tip,
						type: 'warning'
					});
					return
				}
				if (!this.password) {
					this.$message({
						message: this.langInfo.login_password_tip,
						type: 'warning'
					});
					return
				}
				if (!this.nextPassword) {
					this.$message({
						message: this.langInfo.reg_password_tip,
						type: 'warning'
					});
					return
				}
				if (this.password != this.nextPassword) {
					this.$message({
						message: this.langInfo.entered_passwords_differ,
						type: 'warning'
					});
					return
				}
				
				this.$api.resetPasswordByEmail({
					email: this.userInfo.email,
					code: this.code,
					new_password: this.password,
					confirm_password: this.nextPassword
				}).then((res) => {
					console.log(res);
					
							this.$api.login({
								email: this.userInfo.email,
								password: this.password,
								type: 1,
							}).then((resLogin) => {
								// this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
								localStorage.setItem('token', resLogin.data.token)
								
								that.$confirm(that.langInfo['learning center tip'], that.langInfo.reg_tip, {
									confirmButtonText: that.langInfo.head_study_nav,
									cancelButtonText: that.langInfo.cancel,
									type: 'info'
								}).then((ms) => {
									console.log(ms);
									if (ms == "confirm") {
										that.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
									}
								}).catch(() => {
									
								});
								
							}).catch((errorLogin) => {
								that.$message({
									message: errorLogin.msg,
									type: 'warning'
								})
							})
					
				
					
					
					


					
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			}
		}
	}
</script>

<style scoped>
	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -6px;
		left: 50%;
		transform: translateX(-50%);

	}

	input {
		padding: 4px 10px;
		box-sizing: border-box;
		border: 1px solid rgba(220, 224, 231, 1);
		background-color: transparent;
	}

	input::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}
</style>